












































import Component from 'vue-class-component'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {BaseRequest} from '@payroll/optimus-common'
import {Action} from 'vuex-class'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import FeedbackComponent from '../../base/FeedbackComponent'
import GridWidget from '@payroll/grid-widget/src/component/GridWidget.vue'

const searchEmployersPath: string = 'searchEmployers'
const updateEmployerPath: string = 'updateEmployer'

@Component({})
export default class SearchEmployersComponent extends FeedbackComponent {

    private searchFields: SearchFieldModel[] = []
    private columns: GridColumn[] = []
    private showModalIsActive: boolean = false
    private rowSelected: any = null
    private searchObject: any = null

    @Action(searchEmployersPath, StoreNamespace.SEARCH) searchEmployers: any
    @Action(updateEmployerPath, StoreNamespace.SEARCH) updateEmployer: any

    mounted() {
        this.searchFields.push({
            label: 'by_employer_name',
            name: 'employer_name',
            property: 'employerName',
            fieldType: FieldType.TEXT_FIELD,
            maxLength: 100
        })
        this.searchFields.push({
            label: 'by_hp_number',
            name: 'hp_number',
            property: 'employerHp',
            fieldType: FieldType.NUMBER_FIELD,
            maxValue: 999999999
        })
        this.searchFields.push({
            label: 'status',
            property: 'isActive',
            fieldType: FieldType.SELECT_FIELD,
            selectOptions: [{
                value: 'true',
                description: '' + this.$t('active')
            }, {
                value: 'false',
                description: '' + this.$t('un_active')
            }]
        })
        this.initColumns()

        this.loadEmployers({
            isActive: {
                value: 'true',
                description: '' + this.$t('active')
            },
            pageNumber: 0,
            pageSize: GridWidget.DEFAULT_PAGE_SIZE
        })
    }

    private initColumns(): void {
        this.columns.push({property: 'employerHp', header: 'hp_number'} as GridColumn)
        this.columns.push({property: 'employerName', header: 'employer_name'} as GridColumn)
        this.columns.push({property: 'employerNum', header: 'employer_number'} as GridColumn)
        this.columns.push({property: 'status', header: 'status'} as GridColumn)
        this.columns.push({property: 'dateUpdated', header: 'lastStatusDate'} as GridColumn)
        this.columns.push({property: 'updater', header: 'responserName'} as GridColumn)
    }

    loadEmployers(searchObject: any) {
        this.searchObject = searchObject
        this.searchEmployers({
            requestBody: searchObject as BaseRequest,
            requestorCallback: this
        })
    }

    onSuccess(data?: any, requestName?: any, message?: string) {
        switch (requestName) {
            case searchEmployersPath:
                this.$emit('successResults', data)
                break
            case updateEmployerPath:
                this.loadEmployers(this.searchObject)
                break
        }
    }

    onRowClick(row: any) {
        this.rowSelected = row
        this.showModalIsActive = true
    }

    onUpdateEmployer(): void {
        this.showModalIsActive = false
        this.updateEmployer({
            requestorCallback: this,
            requestBody: {
                id: this.rowSelected.id,
                isActive: !this.rowSelected.activeFlag
            } as BaseRequest
        })
    }
}

